import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "..";
import { State } from "../state";
import { LocalStorage } from "@/types/enums";

export const viewSlice = createSlice({
    name: "view",
    initialState: {
        /**
         * @default false
         */
        showExtendedView: localStorage.getItem(LocalStorage.SHOW_EXTENDED_VIEW) === "true",
    } as State.View,
    reducers: {
        setShowExtendedView: (state, action: PayloadAction<boolean>) => {
            const value = action.payload;

            state.showExtendedView = value;
            localStorage.setItem(LocalStorage.SHOW_EXTENDED_VIEW, value.toString());
        },
    },
});

export const { setShowExtendedView } = viewSlice.actions;

export const useViewSlice = () => useSelector((state: RootState) => state.view);

export default viewSlice.reducer;
